import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = ({ translations }) => { // Added translations prop
  const [isHovered, setIsHovered] = useState(false);
  const phoneNumber = "19495687938"; // Your WhatsApp phone number
  const defaultMessage = translations.whatsapp.defaultMessage; // Get default message from translations

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

  return (
    <motion.a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-[#25D366] text-white rounded-full p-4 shadow-fut-glow-md shadow-[#25D366] flex items-center justify-center cursor-pointer z-40" // Original WhatsApp green
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <MessageCircle size={32} />
      {isHovered && (
        <motion.span
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          className="ml-3 text-lg font-bold whitespace-nowrap hidden sm:block"
        >
          Chat on WhatsApp
        </motion.span>
      )}
    </motion.a>
  );
};

export default WhatsAppButton;